// src/components/Logo.js
import React, { useRef } from 'react';

// Clicks reset if more than 2s pass between them, so this only fires for a
// genuine rapid run of 7 - not 7 clicks accumulated over an idle afternoon.
const CLICK_RESET_MS = 2000;
const CLICKS_TO_TRIGGER = 7;

function Logo({ onSevenClicks }) {
    const clickCountRef = useRef(0);
    const lastClickTimeRef = useRef(0);

    const handleClick = () => {
        if (!onSevenClicks) return;

        const now = Date.now();
        clickCountRef.current = now - lastClickTimeRef.current > CLICK_RESET_MS ? 1 : clickCountRef.current + 1;
        lastClickTimeRef.current = now;

        if (clickCountRef.current >= CLICKS_TO_TRIGGER) {
            clickCountRef.current = 0;
            onSevenClicks();
        }
    };

    return (
        <div
            onClick={handleClick}
            style={{ fontWeight: 'bold', fontSize: '1.5rem', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
        >
            <img src="/logo_trans_bk.png" alt="Logo" style={{ height: '60px' }} />
        </div>
    );
}

export default Logo;
